// extracted by mini-css-extract-plugin
export default {"fileSave":"UploadMultipleFiles_fileSave__VnUl4"};